<script>
    import { onMount } from 'svelte';
    import { store, store_init_offer } from '../../Store.svelte';
    import AddonModal from '../../components/AddonModal.svelte';
    import ChannelsModal from '../../components/ChannelsModal.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import AddressModal from '../../components/common/AddressModal.svelte';
    import PlanType from '../../components/comparator/PlanType.svelte';
    import LegalsComponent from '../../components/comparator/components/LegalsComponent.svelte';
    import SelectorOffer from '../../components/comparator/SelectorOffer.svelte';

    onMount(() => {
        try {
            window.document.dispatchEvent(
                new Event('DOMContentLoaded', {
                    bubbles: true,
                    cancelable: true,
                })
            );
        } catch (err) {}
    });

    function popupClick() {}

    $: selected = '3p';
    let checkedVix =
        $store.requestedServices.isVix != undefined
            ? $store.requestedServices.isVix
            : false;
    let checkedNetflix =
        $store.requestedServices.isNetflix != undefined
            ? $store.requestedServices.isNetflix
            : false;
    let checkedHBO =
        $store.requestedServices.isHBO != undefined
            ? $store.requestedServices.isHBO
            : false;
    let checkedCombos =
        $store.requestedServices.isCombo != undefined
            ? $store.requestedServices.isCombo
            : false;
    let tripleplay_modular_combos = [];
    let residencial_modular_combos = [];
    let render = 0;

    const processOfferItems = (
        items,
        combos,
        applyDiscount = false,
        duplicatedItem = true
    ) => {
        items.forEach((item) => {
            if (item.vel === 80 || (item.vel === 100 && !duplicatedItem)) {
                combos.push({ ...item, isNetflix: true });
            } else {
                combos.push({ ...item, isNetflix: true });
            }
            if (duplicatedItem) {
                if (item.vel === 80 || item.vel === 100) {
                    if (applyDiscount) {
                        let cost = parseInt(item.cost).toString();
                        let promoCost = (
                            parseInt(item.promoCost) - 30
                        ).toString();
                        combos.push({
                            ...item,
                            cost: cost,
                            promoCost: promoCost,
                            isNetflix: false,
                            isHBO: true,
                        });
                    } else {
                        combos.push({ ...item, isNetflix: true });
                    }
                }
            }
        });
    };

    const loadData = () => {
        const { loadedOffer } = $store_init_offer;
        const { offers } = loadedOffer;

        if (offers.tripleplay_modular) {
            processOfferItems(
                offers.tripleplay_modular,
                tripleplay_modular_combos,
                true
            );
        }

        if (offers.residencial_modular) {
            processOfferItems(
                offers.residencial_modular,
                residencial_modular_combos,
                false,
                false
            );
        }
    };

    $: if ($store_init_offer.loadedOffer.offers) {
        render += 1;
        if (render <= 1) {
            loadData();
        }
    }

    function onChangePlay(event) {
        selected = event.currentTarget.value;
        checkedVix = false;
        checkedNetflix = false;
        checkedHBO = false;
        validarStreaming();
    }

    function validarStreaming() {
        $store.requestedServices.isVix = $store.requestedServices.isCombo;

        if (
            (checkedNetflix && !$store.requestedServices.isNetflix) ||
            (checkedHBO && !$store.requestedServices.isHBO)
        ) {
            checkedVix = true;
            $store.requestedServices.isVix = checkedVix;
        }

        $store.requestedServices.isNetflix = checkedNetflix;
        $store.requestedServices.isHBO = checkedHBO;
    }

    function onChangeOtt(event) {
        if (event.target.checked) {
            $store.requestedServices.isVix = true;
        } else {
            $store.requestedServices.isVix = false;
        }
        $store.requestedServices.isCombo = checkedCombos;
    }
</script>

{#if $store_init_offer.loadedOffer == null || $store_init_offer.loadedOffer.offers == null}
    <div class="pure-g full-width">
        <div class="pure-u-1">
            <div class="text-center">
                <h2 class="text-fs-23 fw-semibold base-text m-b-5">
                    obteniendo paquetes disponibles
                </h2>
                <p class="text-fs-13 m-b-15">
                    {$store.requestedAddress.addressString},
                    {$store.requestedAddress.postalCode}
                </p>
                <p class="text-fs-13">
                    <a
                        href="#/"
                        on:click|preventDefault={popupClick}
                        class="popup base-text underline"
                        data-custom-open="modal-cobertura">cambiar dirección</a
                    >
                </p>
            </div>
            <div class="pure-g">
                <div class="pure-u-1">
                    <div class="text-center"><Preloader /></div>
                </div>
            </div>
        </div>
    </div>
{:else}
    <script>
        setTimeout(function () {
            try {
                window.document.dispatchEvent(
                    new Event('DOMContentLoaded', {
                        bubbles: true,
                        cancelable: true,
                    })
                );
            } catch (err) {}
        }, 1500);
    </script>
    <div class="pure-g full-width">
        <div class="pure-u-1">
            <h2 class="text-fs-36 fw-semibold text-center m-b-25">
                elige, selecciona y configura tu paquete
            </h2>
            <h3 class="text-fs-26 base-text fw-semibold text-center m-b-10">
                1. elige el servicio que necesitas
            </h3>
            <p class="text-fs-20 base-text text-center m-b-40">
                todos los paquetes con internet incluyen telefonía ilimitada
            </p>
            <div class="package-selectors-wrapper">
                <div class="package-type package-type--3p">
                    <div class="package-type__label">3 play</div>
                    <div class="package-selectors">
                        <SelectorOffer
                            on:updateSelected={onChangePlay}
                            isPhoneIcon={true}
                            isWifiIcon={true}
                            isTvIcon={true}
                            {selected}
                            data_package="tab_izzitvhd"
                            value={'3p'}
                            title="internet + 200 canales de tv"
                        />
                    </div>
                </div>
                <div class="package-type">
                    <div class="package-type__label">2 play</div>
                    <div class="package-selectors">
                        <SelectorOffer
                            on:updateSelected={onChangePlay}
                            isPhoneIcon={true}
                            isWifiIcon={true}
                            {selected}
                            data_package="tab_inttel"
                            value={'2p'}
                            title="internet"
                        />
                    </div>
                </div>
            </div>

            <h3 class="text-fs-26 base-text fw-semibold text-center m-b-30">
                2. selecciona tu izzi combo <br /><span
                    class="text-fs-20 fw-regular">(opcional)</span
                >
            </h3>
            <div class="combo-selectors">
                <div class="combo-item">
                    <input
                        type="checkbox"
                        name="combo_ott"
                        id="combo3ott"
                        data-combo="combo3ott"
                        bind:checked={checkedCombos}
                        on:change={onChangeOtt}
                    />
                    <label for="combo3ott" id="combo3ott-ga4">
                        <span class="addon-check__indicator"
                            ><svg class="icon"
                                ><use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-check"
                                /></svg
                            ></span
                        >
                        <div class="item-content">
                            <p><span>izzi</span> combo</p>
                            <p class="footer-content">streamings incluidos</p>
                        </div>
                    </label>
                </div>
            </div>
            <div class="package-tabs-holder m-b-50">
                <div id="tab_izzitvhd" class="tab-content" class:active={true}>
                    <div class="offers-grid__wrapper">
                        <div class="offers-grid offers-grid--offers-tripleplay">
                            <a href="#/" class="offer-scroll-left"
                                ><svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                    /></svg
                                ></a
                            >
                            <a href="#/" class="offer-scroll-right"
                                ><svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-right"
                                    /></svg
                                ></a
                            >
                            {#if tripleplay_modular_combos != null && $store_init_offer.loadedOffer.offers.tripleplay_modular != null}
                                {#if checkedCombos}
                                    {#each tripleplay_modular_combos as item}
                                        <PlanType
                                            plan={item}
                                            category="tripleplay"
                                            {checkedCombos}
                                            home={true}
                                        />
                                    {/each}
                                {/if}
                                {#if !checkedCombos}
                                    {#each $store_init_offer.loadedOffer.offers.tripleplay_modular as item}
                                        <PlanType
                                            plan={item}
                                            category="tripleplay"
                                            {checkedCombos}
                                            home={true}
                                        />
                                    {/each}
                                {/if}
                            {/if}
                        </div>
                    </div>
                    <LegalsComponent />
                </div>

                <div id="tab_inttel" class="tab-content">
                    <div class="offers-grid__wrapper">
                        <div
                            class="offers-grid offers-grid--offers-residencial"
                        >
                            <a href="#/" class="offer-scroll-left"
                                ><svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                                    /></svg
                                ></a
                            >
                            <a href="#/" class="offer-scroll-right"
                                ><svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-right"
                                    /></svg
                                ></a
                            >
                            {#if residencial_modular_combos != null}
                                {#if checkedCombos}
                                    {#each residencial_modular_combos as item}
                                        <PlanType
                                            plan={item}
                                            category="residencial"
                                            {checkedCombos}
                                            home={true}
                                        />
                                    {/each}
                                {/if}
                                {#if !checkedCombos}
                                    {#each residencial_modular_combos as item}
                                        <PlanType
                                            plan={item}
                                            category="residencial"
                                            {checkedCombos}
                                            home={true}
                                        />
                                    {/each}
                                {/if}
                            {/if}
                        </div>
                    </div>
                    <LegalsComponent />
                </div>
            </div>
        </div>
    </div>
{/if}

<AddonModal />
<ChannelsModal />

<div>
    <div class="modal" id="modal-cobertura" aria-hidden="true">
        <AddressModal home={true} />
    </div>
</div>
